import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="aqua-section bg-navy-grid"
    >
      <div className="aqua-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto text-white"
        >
          <p className="text-eyebrow" style={{ color: "#33BED6" }}>
            Where confidence begins in every wave
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold mt-3 mb-5">
            Dive in today — register now and let's flow together.
          </h2>
          <p className="text-white/80 text-base sm:text-lg leading-relaxed mb-8">
            Whether you're introducing your toddler to the water, helping your child
            grow into a strong swimmer, or finally learning to swim as an adult —
            Agua Flow Mobile brings expert, caring instruction right to you.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/contact"
              data-testid="final-cta-contact"
              className="btn-book"
            >
              Get in Touch <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
